(function () {
	'use strict';
	angular.module('jcsfApp').controller('studentController', studentController);

	studentController.$inject = [
		'$controller',
		'$rootScope',
		'$scope',
		'$filter',
		'$timeout',
		'events',
		'valuesService',
		'authService',
	];

	function studentController(
		$controller,
		$rootScope,
		$scope,
		$filter,
		$timeout,
		events,
		valuesService,
		authService
	) {
		$controller('baseController', { $scope: $scope });

		var vm = this;
		vm.isTransferring = false;
		vm.studentEmailIsUnique = true;
		vm.boolToStr = function (arg) {
			return arg ? 'Yes' : 'No';
		};
		vm.invalidGraduation = function () {
			return (
				vm.student.Graduated &&
				(!vm.student.EducationLevel || !vm.student.PrimaryPhoneNumber)
			);
		};

		vm.forests = [];
		vm.oldCentername, vm.oldCenterId, vm.previousStudenttrade;
		vm.authService = authService;
		vm.userJCCCC = authService.authentication.userInfo.JCCCC;
		vm.isAdmin =
			authService.authentication.userInfo.Roles.includes('Administrator');

		vm.placmentTypes = [
			'(AFMTP) Advanced Fire Management Training Program',
			'Contract Fire Position',
			'FS Fire Position',
			'FS Natural Resource Position',
			//'Miltary',
			'Non-profit Position',
			'Other Federal Fire Position',
			'Other FS Federal Position',
			'Other Federal Position',
			'State Position',
			'(WFAP) Wildland Fire Apprentice Program',
			'Other',
		];
		vm.Apprenticeships = ['Conservation', 'Forest Service'];
		vm.DocumentTypes = ['PDF', 'Word', 'Excel', 'Other'];
		// vm.AgeData = ['Under 15', '15-18', '19-24', '25-35', '36-54', '55 Plus', 'Unknown'];
		vm.AgeData = ['15-18', '19-24', '25-35'];
		vm.EthRaceData = [
			'White (Non-Hispanic)',
			'Black or African (Non-Hispanic)',
			'Hispanic or Latino',
			'Native American/Alaskan Native',
			'Asian/Pacific Islander',
			'Other',
			'Unknown',
		];
		vm.OthDemographicData = [
			'Persons with Disabilities',
			'Veterans Designation',
		];
		vm.SCMethods = ['Manual', 'System'];
		authService.fillAuthData();
		var authentication = authService.authentication;
		vm.userJCCCC = authentication.userInfo.JCCCC;
		vm.centerId = authentication.userInfo.JCCCC;
		vm.centerName = '';
		vm.student = {
			StudentId: 0,
			StudentPicture: '',
			FirstName: '',
			MiddleInitial: '',
			LastName: '',
			DOBMonthYear: '',
			PrimaryPhoneNumber: '',
			PersonalEmailAddress: '',
			FSPhoneNumber: '',
			FSEmailAddress: 0,
			JCStartDate: new Date(),
			JCStartDate2: new Date(),
			PLCCertificateRecieved: '',
			PLCCertificateDate: new Date(),
			JCCCC: vm.centerId,
			CenterName: '',
			EducationLevel: '',
			Credentials: '',
			StudentType: '',
			StudentTrade: '',
			StudentBio: '',
			Gender: '',
			Ethnicity: '',
			PersonWithDisabilities: 0,
			Veteran: 0,
			EmploymentFirePlacement: 0,
			Employer: '',
			HiringAuthority: [],
			PlacementDate: new Date(),
			SupervisorRemarks: '',
			JCGraduationDate: new Date(),
			ICSPosition: '',
			Active: 1,
			Deleted: 0,
			Creator: '',
			LastModifiedBy: '',
			CreatedDate: null,
			CreatedDateString: '',
			CreatedBy: '',
			LastUpdated: null,
			LastUpdatedString: '',
			LastUpdatedBy: '',
			UpdatingApp: '',
			PublicHours: [],
			NonPublicHours: [],
			FireHours: [],
			JobTitle: '',
			JobLocations: '',
			Salary: 0,
			EthnicityAndRace: '',
			OtherDemographic: '',
		};
		vm.tabs = [
			{ title: 'Student Info', url: '/app/students/views/studentInfo.html' },
		];
		vm.currentTab = '/app/students/views/studentInfo.html';
		vm.onClickTab = function (tab) {
			if (tab.url === '/app/students/views/publicHours.html') {
				vm.selectedStudentHour = createStudentHourModel();
			}
			if (tab.url === '/app/students/views/firehours.html') {
				vm.selectedFireHour = createFireHourModel();
			}
			if (tab.url === '/app/students/views/communityHours.html') {
				vm.selectedNPHour = createCommunityHourModel();
			}
			vm.currentTab = tab.url;
		};
		vm.getNewCenterName = function (center) {
			var centerN = $filter('filter')(vm.centers, { CenterId: center })[0];
			return centerN.JCCCC;
		};
		vm.focusAControl = function (controlID) {
			$timeout(function () {
				document.getElementById(controlID).focus();
			});
		};
		vm.transferCenter = 0;
		vm.transferStudent = function (newCenter) {
			vm.student.JCCCC = newCenter;
			vm.student.UpdatedCenters =
				(vm.student.UpdatedCenters ? vm.student.UpdatedCenters + ',' : '') +
				vm.oldCenterId;
			vm.save();
			vm.isTransferring = false;
			vm.transferCenter = 0;
		};

		vm.isActiveTab = function (tabUrl) {
			return tabUrl === vm.currentTab;
		};
		vm.resources = [];
		vm.centers = [];
		vm.communityProjects = [];
		vm.publicProjects = [];
		vm.stateList = valuesService.stateList;
		vm.selectedStudentHour = {};
		vm.selectedFireHour = {};
		vm.selectedCommunityHour = {};
		vm.selectedNPHour = {};
		vm.saveStudentHours = function (fh) {
			if (fh.StudentHoursId > 0) {
				fh.LastModifiedBy = authentication.userName;
			} else {
				fh.Creator = authentication.userName;
			}
			$scope.publish(events.message._SAVE_STUDENT_HOUR_, [fh]);
			vm.selectedStudentHour = createStudentHourModel();
		};
		vm.recall = function () {
			vm.student.Active = 2;
			vm.student.Deleted = 0;
			vm.save();
		};
		vm.editCommunityHour = function (np) {
			vm.selectedNPHour = createCommunityHourModel(np);
			vm.selectedNPHour.Hours = parseFloat(
				Math.round(vm.selectedNPHour.Hours * 100) / 100
			).toFixed(2);
		};
		vm.deleteCommunityHour = function (np) {
			var confirmed = window.confirm(
				'Are you sure you want to delete ' +
					np.FirstName +
					' ' +
					np.LastName +
					' ' +
					np.ProjectDescription +
					' Hours (' +
					np.Hours +
					') ?'
			);

			if (confirmed) {
				$scope.publish(events.message._DELETE_NON_PUBLIC_HOUR_, [np.NPHoursId]);
			}
		};
		vm.saveCommunityHours = function (fh) {
			if (fh.NPHoursId > 0) {
				fh.LastModifiedBy = authentication.userName;
			} else {
				fh.Creator = authentication.userName;
			}
			$scope.publish(events.message._SAVE_NON_PUBLIC_HOUR_, [fh]);
			vm.selectedNPHour = createCommunityHourModel();
		};

		//open popup when we check genereate PLC certificate
		vm.PLCcertificateComponent = function () {
			return true;
		};

		//change event of Split Count checkbox
		vm.splitCount = function (event) {
			if (vm.student.SplitCount) {
				vm.student.SplitCountMethod = 'Manual';
			} else {
				vm.student.SplitCountMethod = 'System';
			}
		};

		vm.generatePlcCertificate = function generatePlcCertificate() {
			var plcCertificateTemplate = $('#PLCcertiDiv');
			plcCertificateTemplate.css('display', 'block');

			html2canvas(plcCertificateTemplate[0]).then(function (canvas) {
				var mm = 3.76563;
				var width = Math.floor(canvas.width / mm);
				var height = Math.floor(canvas.height / mm);

				var imgData = canvas.toDataURL();
				var pdf = new jspdf.jsPDF('p', 'mm', [width, height], true);
				pdf.internal.pageSize.setWidth(width);
				pdf.internal.pageSize.setHeight(height);
				pdf.addImage(imgData, 'JPEG', 10, 10, width - 20, height, '', 'FAST');
				pdf.save(
					vm.student.FirstName +
						' ' +
						vm.student.LastName +
						' PLC Certificate ' +
						new Date().toLocaleString('default', { month: 'long' }) +
						' ' +
						new Date().getFullYear() +
						'.pdf'
				);

				plcCertificateTemplate.css('display', 'none');
			});
		};

		vm.CheckPLCCertificateDateValue = function (event) {
			vm.student.PLCCertificateDate = FormatDate(
				document.getElementById('PLCCertificateDate2').value
			);
		};

		vm.deleteStudentHour = function (fh) {
			const confirmed = window.confirm(
				'Are you sure you want to delete ' +
					fh.FirstName +
					' ' +
					fh.LastName +
					' ' +
					fh.ResourceName +
					' Hours (' +
					fh.Hours +
					') ?'
			);

			if (confirmed) {
				$scope.publish(events.message._DELETE_STUDENT_HOUR_, [
					fh.StudentHoursId,
				]);
			}
		};
		vm.editStudentHour = function (fh) {
			vm.selectedStudentHour = createStudentHourModel(fh);
			vm.selectedStudentHour.Hours = parseFloat(
				Math.round(vm.selectedStudentHour.Hours * 100) / 100
			);
			vm.selectedStudentHour.EstimatedHours = parseFloat(
				Math.round(vm.selectedStudentHour.EstimatedHours * 100) / 100
			);
		};
		vm.saveFireHours = function (fh) {
			if (fh.FireHourId > 0) {
				fh.LastModifiedBy = authentication.userName;
			} else {
				fh.Creator = authentication.userName;
			}
			$scope.publish(events.message._SAVE_FIRE_HOUR_, [fh]);
			vm.selectedFireHour = createFireHourModel();
		};
		vm.deleteFireHour = function (fh) {
			const confirmed = window.confirm(
				'Are you sure you want to delete ' +
					fh.ProjectTitle +
					' Hours (' +
					fh.Hours +
					') ?'
			);

			if (confirmed) {
				$scope.publish(events.message._DELETE_FIRE_HOUR_, [fh.FireHourId]);
			}
		};
		vm.editFireHour = function (fh) {
			vm.selectedFireHour = createFireHourModel(fh);

			vm.selectedFireHour.Hours = parseFloat(
				Math.round(vm.selectedFireHour.Hours * 100) / 100
			).toFixed(2);
		};
		vm.cancel = function () {
			$scope.publish(events.message._GET_STUDENT_, [vm.student.StudentId]);
		};
		vm.totalPublicHours = function () {
			var totalHours = 0;
			vm.student.PublicHours.forEach(function (item) {
				totalHours = totalHours + Number(item.Hours);
			});
			return $filter('number')(totalHours, 2);
		};
		vm.totalFireHours = function () {
			var totalHours = 0;
			vm.student.FireHours.forEach(function (item) {
				totalHours = totalHours + Number(item.Hours);
			});
			return $filter('number')(totalHours, 2);
		};
		vm.totalCommunityHours = function () {
			var totalHours = 0;
			if (vm.student.CommunityHours) {
				vm.student.CommunityHours.forEach(function (item) {
					totalHours = totalHours + Number(item.Hours);
				});
			}
			return $filter('number')(totalHours, 2);
		};
		vm.totalHours = function () {
			var totalHours = 0;
			vm.student.PublicHours.forEach(function (item) {
				totalHours = totalHours + Number(item.Hours);
			});
			vm.student.FireHours.forEach(function (item) {
				totalHours = totalHours + Number(item.Hours);
			});
			if (vm.student.CommunityHours) {
				vm.student.CommunityHours.forEach(function (item) {
					totalHours = totalHours + Number(item.Hours);
				});
			}
			return $filter('number')(totalHours, 2);
		};

		vm.save = function () {
			if (vm.student.StudentId > 0) {
				vm.student.LastModifiedBy = authentication.userName;
			} else {
				vm.student.Creator = authentication.userName;
			}

			vm.student.HiringAuthority = vm.student.HiringAuthorityList.toString();
			vm.student.Credentials = vm.student.CredentialsList.toString();
			vm.student.ICSPosition = vm.student.ICSPositionList.toString();
			vm.student.StudentTrade = vm.student.TradesList.toString();
			vm.student.ICSTraineePosition =
				vm.student.ICSTraineePositionList.toString();

			if (vm.student.StudentTrade != vm.previousStudenttrade) {
				vm.student.PreviousStudentTrade =
					(vm.student.PreviousStudentTrade
						? vm.student.PreviousStudentTrade + ','
						: '') + vm.previousStudenttrade;
			} else {
				vm.student.PreviousStudentTrade = vm.student.PreviousStudentTrade;
			}

			const student = structuredClone(vm.student);
			if (student.JCGraduationDate) {
				student.JCGraduationDate = $filter('date')(
					student.JCGraduationDate,
					'MM/dd/yyyy'
				);
			}

			$scope.publish(events.message._SAVE_STUDENT_, [student]);
		};

		activate();
		$scope.subscribe(
			events.message._GET_STUDENT_COMPLETE_,
			onGetStudentComplete
		);
		$scope.subscribe(
			events.message._CHECK_STUDENT_EMAIL_EXIST_COMPLETE_,
			onCheckStudentEmailComplete
		);
		$scope.subscribe(
			events.message._GET_STUDENT_RESOURCES_LIST_COMPLETE_,
			onGetStudentResourcesComplete
		);
		$scope.subscribe(
			events.message._SAVE_STUDENT_COMPLETE_,
			onSaveStudentComplete
		);
		$scope.subscribe(
			events.message._SAVE_FIRE_HOUR_COMPLETE_,
			onSaveFireHourComplete
		);
		$scope.subscribe(
			events.message._DELETE_FIRE_HOUR_COMPLETE_,
			onDeleteFireHourComplete
		);
		$scope.subscribe(
			events.message._SAVE_STUDENT_HOUR_COMPLETE_,
			onSaveHourComplete
		);
		$scope.subscribe(
			events.message._DELETE_STUDENT_HOUR_COMPLETE_,
			onDeleteFireHourComplete
		);
		$scope.subscribe(
			events.message._GET_JCCENTER_LIST_COMPLETE_,
			onGetJcCentersComplete
		);
		$scope.subscribe(events.message._GET_RSA_LIST_COMPLETE_, onGetRSAsComplete);
		$scope.subscribe(
			events.message._GET_PROJECT_LIST_COMPLETE_,
			onGetPublicProjectsComplete
		);
		$scope.subscribe(
			events.message._DELETE_NON_PUBLIC_HOUR_COMPLETE_,
			onDeleteFireHourComplete
		);
		$scope.subscribe(
			events.message._GET_NON_PUBLIC_PROJECT_LIST_COMPLETE_,
			onGetCommunityProjectsComplete
		);
		$scope.subscribe(
			events.message._SAVE_NON_PUBLIC_HOUR_COMPLETE_,
			onSaveHourComplete
		);
		$scope.subscribe(
			events.message._GET_FOREST_LIST_COMPLETE_,
			onGetForestsComplete
		);
		$scope.subscribe(
			events.message._MAIL_NOTIFICATION_COMPLETE_,
			onMailNotificationComplete
		);

		function activate() {
			if (authentication.userName == null || !authentication.isAuth) {
				$scope.$state.go('login');
			}
			if ($rootScope.$stateParams.id == null) {
				$scope.$state.go('home');
			}
			$scope.publish(events.message._GET_JCCENTER_LIST_, []);
			$scope.publish(events.message._GET_STUDENT_RESOURCES_LIST_, []);
			$scope.publish(events.message._GET_FOREST_LIST_, []);

			$scope.publish(events.message._GET_STUDENT_, [
				$rootScope.$stateParams.id,
				$rootScope.$stateParams.ctr,
			]);
		}
		function createStudentHourModel(src) {
			var self = {};
			src = src || {};
			self.StudentHoursId = src.StudentHoursId || 0;
			self.StudentHourProjectId = src.StudentHourProjectId || 0;
			self.StudentId = vm.student.StudentId;
			self.CenterId = src.CenterId || 0;
			self.Experience = src.Experience || '';
			self.StudentResourceId = src.StudentResourceId || 0;
			self.FocusArea = src.FocusArea || '';
			self.FunctionalAreaId = src.FunctionalAreaId || 0;
			self.FunctionArea = src.FunctionArea || '';
			self.ResourceName = src.ResourceName || '';
			self.DispatchDate = new Date(src.DispatchDate);
			self.ReturnedDate = new Date(src.ReturnedDate);
			self.CalendarYear = src.CalendarYear || 0;
			self.Hours = src.Hours || 0;
			self.FirstName = src.FirstName || '';
			self.MiddleInitial = src.MiddleInitial || '';
			self.IsPLC = src.IsPLC || false;
			self.ProjectName = src.ProjectName || '';
			self.PartnerOrg = src.PartnerOrg || '';
			self.ProjectSite = src.ProjectSite || '';
			self.LastName = src.LastName || '';
			self.ForestName = src.ForestName || '';
			self.Comments = src.Comments || '';
			self.Active = src.Active || 1;
			self.Deleted = src.Deleted || 0;
			self.Creator = src.Creator || '';
			self.LastModifiedBy = src.LastModifiedBy || '';
			self.CreatedDate = new Date(src.CreatedDate);
			self.CreatedDateString = src.CreatedDateString || '';
			self.CreatedBy = src.CreatedBy || '';
			self.LastUpdated = new Date(src.LastUpdated);
			self.LastUpdatedString = src.LastUpdatedString || '';
			self.LastUpdatedBy = src.LastUpdatedBy || '';
			self.UpdatingApp = src.UpdatingApp || '';
			return self;
		}
		function createCommunityHourModel(src) {
			var self = {};
			src = src || {};
			self.NPHoursId = src.NPHoursId || 0;
			self.ProjectId = src.ProjectId || 0;
			self.ProjectDescription = src.ProjectDescription || '';
			self.StudentId = src.StudentId || vm.student.StudentId;
			self.CalendarYear = src.CalendarYear || 0;
			self.FirstName = src.FirstName || '';
			self.MiddleInitial = src.MiddleInitial || '';
			self.LastName = src.LastName || '';
			self.ForestName = src.ForestName || '';
			self.IsPLC = src.IsPLC || false;
			self.DispatchDate = new Date(src.DispatchDate);
			self.ReturnedDate = new Date(src.ReturnedDate);
			self.EstimatedHours = src.EstimatedHours || 0;
			self.Hours = src.Hours || 0;
			self.Active = src.Active || 1;
			self.Deleted = src.Deleted || 0;
			self.Creator = src.Creator || '';
			self.LastModifiedBy = src.LastModifiedBy || '';
			self.CreatedDate = new Date(src.CreatedDate);
			self.CreatedDateString = src.CreatedDateString || '';
			self.CreatedBy = src.CreatedBy || '';
			self.LastUpdated = new Date(src.LastUpdated);
			self.LastUpdatedString = src.LastUpdatedString || '';
			self.LastUpdatedBy = src.LastUpdatedBy || '';
			self.UpdatingApp = src.UpdatingApp || '';
			self.AllProjectsVerified = src.AllProjectsVerified || false;
			return self;
		}
		function createFireHourModel(src) {
			var self = {};
			src = src || {};
			self.FireHourId = src.FireHourId || 0;
			self.StudentId = vm.student.StudentId;
			self.CalendarYear = src.CalendarYear || 0;
			self.FirstName = src.FirstName || '';
			self.MiddleInitial = src.MiddleInitial || '';
			self.LastName = src.LastName || '';
			self.ForestName = src.ForestName || '';
			self.ProjectId = src.ProjectId || 0;
			self.ProjectOrganizationName = src.ProjectOrganizationName || '';
			self.ProjectTitle = src.ProjectTitle || '';
			self.ProjectSubTitle = src.ProjectSubTitle || '';
			self.DispatchDate = new Date(src.DispatchDate);
			self.DateReturned = new Date(src.DateReturned);
			self.AnticipatedDurationInDays = src.AnticipatedDurationInDays || 0;
			self.EstimatedHours = src.EstimatedHours || 0;
			self.Hours = src.Hours || 0;
			self.ResourceId = src.ResourceId || 0;
			self.ResourceName = src.ResourceName || '';
			self.HoursTypeId = src.HoursTypeId || 0;
			self.IsPLC = src.IsPLC || true;
			self.TypeOfHours = src.TypeOfHours || '';
			self.Comments = src.Comments || '';
			self.Active = src.Active || 1;
			self.Deleted = src.Deleted || 0;
			self.Creator = src.Creator || '';
			self.LastModifiedBy = src.LastModifiedBy || '';
			self.CreatedDate = new Date(src.CreatedDate);
			self.CreatedDateString = src.CreatedDateString || '';
			self.CreatedBy = src.CreatedBy || '';
			self.LastUpdated = new Date(src.LastUpdated);
			self.LastUpdatedString = src.LastUpdatedString || '';
			self.LastUpdatedBy = src.LastUpdatedBy || '';
			self.UpdatingApp = src.UpdatingApp || '';
			return self;
		}
		function onGetStudentComplete(results) {
			results.JCStartDate = new Date(results.JCStartDate);
			results.DateAvailable = new Date(results.DateAvailable);
			vm.student = results;

			if (vm.student.SplitCount) {
				vm.student.SplitCountMethod = 'Manual';
			} else {
				vm.student.SplitCountMethod = 'System';
			}

			var center = vm.centers.find(function (center) {
				return center.CenterId === vm.student.JCCCC;
			});
			vm.oldCentername = center.JCCCC;
			vm.oldCenterId = center.CenterId;
			vm.previousStudenttrade = vm.student.StudentTrade;

			$scope.publish(events.message._GET_PROJECT_LIST_, [
				true,
				vm.student.JCCCC,
			]);
			vm.student.HiringAuthorityList = vm.student.HiringAuthority.split(',');
			$scope.publish(events.message._GET_NON_PUBLIC_PROJECT_LIST_, [
				true,
				vm.student.JCCCC,
			]);
			vm.student.CredentialsList = vm.student.Credentials.split(',');
			vm.student.ICSPositionList = vm.student.ICSPosition.split(',');
			vm.student.TradesList = vm.student.StudentTrade.split(',').filter(
				function (trade) {
					return trade.length > 0;
				}
			);
			vm.student.ICSTraineePositionList =
				vm.student.ICSTraineePosition.split(',');
			if (vm.student.StudentId > 0) {
				if (
					(vm.isAdmin || vm.userJCCCC === 29) &&
					vm.student.TotalPLCHours >= 640 &&
					!vm.student.GeneratePLCCertificate
				) {
					setTimeout(function () {
						var willGeneratePlcCertificate = window.confirm(
							'Please generate PLC certificate for this student as student has satisfied the requirement of 640 total PLC hours.'
						);
						if (willGeneratePlcCertificate) {
							vm.student.GeneratePLCCertificate = true;
							vm.generatePlcCertificate();
							vm.save();
						}
					}, 100);
				}

				vm.tabs = [
					{
						title: 'Student Info',
						url: '/app/students/views/studentInfo.html',
					},
					{ title: 'FS Hours', url: '/app/students/views/publicHours.html' },
					{ title: 'Fire Hours', url: '/app/students/views/firehours.html' },
					{
						title: 'Rural Development Hours',
						url: '/app/students/views/communityHours.html',
					},
				];
			}
		}
		function onGetCommunityProjectsComplete(results) {
			vm.communityProjects = results;
		}
		function onGetStudentResourcesComplete(results) {
			vm.resources = results;
		}
		function onSaveStudentComplete(results) {
			onGetStudentComplete(results);
		}
		function onGetJcCentersComplete(results) {
			vm.centers = results;
			if (vm.userJCCCC !== 29) {
				vm.centerId = vm.userJCCCC;
			} else if ($rootScope.$stateParams.ctr != null) {
				if (vm.userJCCCC !== 29) {
					vm.centerId = vm.userJCCCC;
				} else {
					vm.centerId = $rootScope.$stateParams.ctr;
				}
			}
			vm.centerName =
				$filter('filter')(vm.centers, { CenterId: vm.centerId })[0].JCCCC || '';
		}
		function onMailNotificationComplete(results) {
			vm.centers = results;
		}
		function onGetRSAsComplete(results) {
			vm.rsas = results;
		}
		function onGetPublicProjectsComplete(results) {
			vm.publicProjects = results;
		}
		function onSaveFireHourComplete(results) {
			if (results && results.FireHourId > 0) {
				var match;
				if (vm.student.FireHours) {
					match = vm.student.FireHours.filter(function (item) {
						return Number(item.FireHourId) === Number(results.FireHourId);
					})[0];
				}
				if (match) {
					var inx = vm.student.FireHours.indexOf(match);
					vm.student.FireHours[inx] = results;
				} else {
					vm.student.FireHours.push(results);
				}
			}
		}
		function onSaveHourComplete() {
			$scope.publish(events.message._GET_STUDENT_, [vm.student.StudentId]);
		}
		function onDeleteFireHourComplete() {
			$scope.publish(events.message._GET_STUDENT_, [vm.student.StudentId]);
		}
		function onGetForestsComplete(results) {
			vm.forests = results;
		}
		vm.checkUniqueEmail = function (email) {
			$scope.publish(events.message._CHECK_STUDENT_EMAIL_EXIST_, [email]);
		};
		function onCheckStudentEmailComplete(isExistingEmail) {
			if (vm.student && vm.student.StudentId < 1) {
				vm.studentEmailIsUnique = !isExistingEmail;
				if (isExistingEmail) {
					alert('Email is already in system');
				}
			} else {
				vm.studentEmailIsUnique = true;
			}
		}

		function FormatDate(date) {
			if (date) {
				if (!(date instanceof Date)) {
					date = new Date(date + 'T00:00:00-0500');
				}
				const dateTimeFormat = new Intl.DateTimeFormat('en', {
					year: 'numeric',
					month: '2-digit',
					day: '2-digit',
				});
				const [{ value: month }, , { value: day }, , { value: year }] =
					dateTimeFormat.formatToParts(date);

				return `${month}/${day}/${year}`;
			} else {
				return null;
			}
		}
	}
})();
